import { render, staticRenderFns } from "./vForm.vue?vue&type=template&id=2971673b&scoped=true"
import script from "./vForm.vue?vue&type=script&lang=js"
export * from "./vForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971673b",
  null
  
)

export default component.exports